import { AutogenModelBrTrackingCtrl, AutogenRowBrTrackingCtrl } from "./autogen/AutogenModelBrTrackingCtrl";

export class ModelBrTrackingCtrl extends AutogenModelBrTrackingCtrl<RowBrTrackingCtrl> {
    constructor() {
        super(RowBrTrackingCtrl);
    }
}

export class RowBrTrackingCtrl extends AutogenRowBrTrackingCtrl {
}